// @generated by protoc-gen-connect-es v0.10.0 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.assessment.teacher.apis.proto (package geneo.lms.assessment.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AssessmentAssignmentSubmitRequest, AssessmentAssignmentSubmitResponse, AssessmentAssignmentSubmitV2Request, AssessmentCreationSubmitRequest, AssessmentCreationSubmitResponse, AssessmentCreationSubmitV2Request, AssessmentCreationSubmitV3Request, AssessmentCreationSubmitV4Request, AssessmentCreationSubmitV6Request, CheckValidPromptRequest, CheckValidPromptResponse, CreateQuestionPaperTemplateRequest, CreateQuestionPaperTemplateResponse, CreateQuestionPaperTemplateV2Request, DeleteTeacherCreatedAssessmentRequest, DeleteTeacherCreatedAssessmentResponse, FetchSectionStudentsRequest, FetchSectionStudentsResponse, FetchTeacherAssessmentReportsRequest, FetchTeacherAssessmentReportsResponse, GetAttendanceRequest, GetAttendanceResponse, GetModuleFilteredQuestionsRequest, GetModuleFilteredQuestionsResponse, GetModuleFilteredQuestionsV2Request, GetModuleFilteredQuestionsV2Response, GetModuleFilteredQuestionsV3Request, GetModuleFilteredQuestionsV3Response, GetModuleFilteredQuestionsV4Request, GetModuleFilteredQuestionsV5Request, GetModuleFilteredQuestionsV6Request, GetModuleFilteredQuestionsV6Response, GetModuleFilteredQuestionsV7Request, GetModuleFilteredQuestionsV7Response, GetModuleFilteredQuestionsV8Request, GetModuleFilteredQuestionsV8Response, GetModuleQuestionStatsV2Request, GetModuleQuestionStatsV2Response, GetModuleQuestionStatsV3Request, GetModuleQuestionStatsV3Response, GetQuestionPaperTemplateRequest, GetQuestionPaperTemplateResponse, GetQuestionPaperTemplateV2Request, GetTeacherAssessmentsListRequest, GetTeacherAssessmentsListResponse, MarkAttendanceRequest, MarkAttendanceResponse, SubmitQuestionFeedbackRequest, SubmitQuestionFeedbackResponse, TeacherAssessmentClassStatsRequest, TeacherAssessmentClassStatsResponse, TeacherAssessmentClassStatsV2Request, TeacherAssessmentClassStatsV2Response, TeacherAssessmentClassStatsV3Request, TeacherAssessmentClassStatsV3Response, TeacherOmrAssessmentClassStatsRequest, TeacherOmrAssessmentClassStatsResponse, TeacherStudentOmrResponseFetchRequest, TeacherStudentOmrResponseFetchResponse } from "./lms.assessment.teacher.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1
 */
export const LmsAssessmentTeacherAPIServiceV1 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getTeacherAssessmentsList
     */
    getTeacherAssessmentsList: {
      name: "getTeacherAssessmentsList",
      I: GetTeacherAssessmentsListRequest,
      O: GetTeacherAssessmentsListResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.assessmentCreationSubmit
     */
    assessmentCreationSubmit: {
      name: "assessmentCreationSubmit",
      I: AssessmentCreationSubmitRequest,
      O: AssessmentCreationSubmitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.assessmentAssignmentSubmit
     */
    assessmentAssignmentSubmit: {
      name: "assessmentAssignmentSubmit",
      I: AssessmentAssignmentSubmitRequest,
      O: AssessmentAssignmentSubmitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsRequest,
      O: GetModuleFilteredQuestionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getModuleQuestionStats
     */
    getModuleQuestionStats: {
      name: "getModuleQuestionStats",
      I: GetModuleQuestionStatsV2Request,
      O: GetModuleQuestionStatsV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getAssessmentClassStats
     */
    getAssessmentClassStats: {
      name: "getAssessmentClassStats",
      I: TeacherAssessmentClassStatsRequest,
      O: TeacherAssessmentClassStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.deleteTeacherCreatedAssessment
     */
    deleteTeacherCreatedAssessment: {
      name: "deleteTeacherCreatedAssessment",
      I: DeleteTeacherCreatedAssessmentRequest,
      O: DeleteTeacherCreatedAssessmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.createQuestionPaperTemplate
     */
    createQuestionPaperTemplate: {
      name: "createQuestionPaperTemplate",
      I: CreateQuestionPaperTemplateRequest,
      O: CreateQuestionPaperTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getQuestionPaperTemplate
     */
    getQuestionPaperTemplate: {
      name: "getQuestionPaperTemplate",
      I: GetQuestionPaperTemplateRequest,
      O: GetQuestionPaperTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.fetchSectionStudents
     */
    fetchSectionStudents: {
      name: "fetchSectionStudents",
      I: FetchSectionStudentsRequest,
      O: FetchSectionStudentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.checkValidPrompt
     */
    checkValidPrompt: {
      name: "checkValidPrompt",
      I: CheckValidPromptRequest,
      O: CheckValidPromptResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.submitQuestionFeedback
     */
    submitQuestionFeedback: {
      name: "submitQuestionFeedback",
      I: SubmitQuestionFeedbackRequest,
      O: SubmitQuestionFeedbackResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getOmrAssessmentClassStats
     */
    getOmrAssessmentClassStats: {
      name: "getOmrAssessmentClassStats",
      I: TeacherOmrAssessmentClassStatsRequest,
      O: TeacherOmrAssessmentClassStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV1.getStudentAssessmentOmrResponse
     */
    getStudentAssessmentOmrResponse: {
      name: "getStudentAssessmentOmrResponse",
      I: TeacherStudentOmrResponseFetchRequest,
      O: TeacherStudentOmrResponseFetchResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2
 */
export const LmsAssessmentTeacherAPIServiceV2 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.getAssessmentClassStats
     */
    getAssessmentClassStats: {
      name: "getAssessmentClassStats",
      I: TeacherAssessmentClassStatsV2Request,
      O: TeacherAssessmentClassStatsV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV2Request,
      O: GetModuleFilteredQuestionsV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.assessmentCreationSubmit
     */
    assessmentCreationSubmit: {
      name: "assessmentCreationSubmit",
      I: AssessmentCreationSubmitV2Request,
      O: AssessmentCreationSubmitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.assessmentAssignmentSubmit
     */
    assessmentAssignmentSubmit: {
      name: "assessmentAssignmentSubmit",
      I: AssessmentAssignmentSubmitV2Request,
      O: AssessmentAssignmentSubmitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.createQuestionPaperTemplate
     */
    createQuestionPaperTemplate: {
      name: "createQuestionPaperTemplate",
      I: CreateQuestionPaperTemplateV2Request,
      O: CreateQuestionPaperTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.getQuestionPaperTemplate
     */
    getQuestionPaperTemplate: {
      name: "getQuestionPaperTemplate",
      I: GetQuestionPaperTemplateV2Request,
      O: GetQuestionPaperTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.getAttendance
     */
    getAttendance: {
      name: "getAttendance",
      I: GetAttendanceRequest,
      O: GetAttendanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV2.markAttendance
     */
    markAttendance: {
      name: "markAttendance",
      I: MarkAttendanceRequest,
      O: MarkAttendanceResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherReportsAPIServiceV1
 */
export const LmsAssessmentTeacherReportsAPIServiceV1 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherReportsAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherReportsAPIServiceV1.teacherAssessmentReportsResponse
     */
    teacherAssessmentReportsResponse: {
      name: "teacherAssessmentReportsResponse",
      I: FetchTeacherAssessmentReportsRequest,
      O: FetchTeacherAssessmentReportsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV3
 */
export const LmsAssessmentTeacherAPIServiceV3 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV3",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV3.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV3Request,
      O: GetModuleFilteredQuestionsV3Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV3.assessmentCreationSubmit
     */
    assessmentCreationSubmit: {
      name: "assessmentCreationSubmit",
      I: AssessmentCreationSubmitV3Request,
      O: AssessmentCreationSubmitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV3.getModuleQuestionStats
     */
    getModuleQuestionStats: {
      name: "getModuleQuestionStats",
      I: GetModuleQuestionStatsV3Request,
      O: GetModuleQuestionStatsV3Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV3.getAssessmentClassStats
     */
    getAssessmentClassStats: {
      name: "getAssessmentClassStats",
      I: TeacherAssessmentClassStatsV3Request,
      O: TeacherAssessmentClassStatsV3Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV4
 */
export const LmsAssessmentTeacherAPIServiceV4 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV4",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV4.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV4Request,
      O: GetModuleFilteredQuestionsV3Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV4.assessmentCreationSubmit
     */
    assessmentCreationSubmit: {
      name: "assessmentCreationSubmit",
      I: AssessmentCreationSubmitV4Request,
      O: AssessmentCreationSubmitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV4.checkValidPrompt
     */
    checkValidPrompt: {
      name: "checkValidPrompt",
      I: CheckValidPromptRequest,
      O: CheckValidPromptResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV5
 */
export const LmsAssessmentTeacherAPIServiceV5 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV5",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV5.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV5Request,
      O: GetModuleFilteredQuestionsV3Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV6
 */
export const LmsAssessmentTeacherAPIServiceV6 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV6",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV6.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV6Request,
      O: GetModuleFilteredQuestionsV6Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV6.assessmentCreationSubmit
     */
    assessmentCreationSubmit: {
      name: "assessmentCreationSubmit",
      I: AssessmentCreationSubmitV6Request,
      O: AssessmentCreationSubmitResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV7
 */
export const LmsAssessmentTeacherAPIServiceV7 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV7",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV7.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV7Request,
      O: GetModuleFilteredQuestionsV7Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV8
 */
export const LmsAssessmentTeacherAPIServiceV8 = {
  typeName: "geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV8",
  methods: {
    /**
     * @generated from rpc geneo.lms.assessment.teacher.apis.LmsAssessmentTeacherAPIServiceV8.getModuleQuestionsWithFilters
     */
    getModuleQuestionsWithFilters: {
      name: "getModuleQuestionsWithFilters",
      I: GetModuleFilteredQuestionsV8Request,
      O: GetModuleFilteredQuestionsV8Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

